export abstract class NotEmptyName {
  private _name: string

  constructor (name: string) {
    if (!name) {
      throw new TypeError('Name must be not empty')
    }
    this._name = name
  }

  name (): string {
    return this._name
  }
}
